import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=59abefec&scoped=true"
import script from "./Popover.vue?vue&type=script&setup=true&lang=ts"
export * from "./Popover.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Popover.vue?vue&type=style&index=0&id=59abefec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59abefec",
  null
  
)

export default component.exports